module.exports = __webpack_public_path__ + "static/img/779e6fab5971d4d6c72b1605385030b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/images/green.svg
// module id = 1099
// module chunks = 1